import { createSlice } from "@reduxjs/toolkit";

export const userWalletSlice = createSlice({
    name: 'wallet',
    initialState: {
        address: null,
        balance: 0,
        decimal: 8,
        referralReward: 0,
        referrerWallet: "0x0000000000000000000000000000000000000000"
    }, 

    reducers: {

        setAddress: (state, action) => {
            if(action.payload===undefined)
                return {...state, address: null}
            return {...state, address: action.payload}
        },

        setBalance: (state, action) => {
            if(action.payload===undefined)
                return {...state, balance: 0}
            return {...state, balance: action.payload}
        },

        setDecimal: (state, action) => {
            if(action.payload===undefined)
                return {...state, decimal: 8}
            return {...state, decimal: action.payload}
        },

        setReferralReward: (state, action) => {
            if(action.payload===undefined)
                return {...state, referralReward: 0}
            return {...state, referralReward: action.payload}
        },

        setReferrerWallet: (state, action) => {
            if(action.payload===undefined)
                return {...state, referrerWallet: "0x0000000000000000000000000000000000000000"}
            return {...state, referrerWallet: action.payload}
        }
        
    },
});

export const {setAddress, setBalance, setDecimal, setReferralReward, setReferrerWallet} = userWalletSlice.actions;

export const selectAddress = state=> state.userWallet.address;

export default userWalletSlice.reducer;